import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ie_token", data.token);
      localStorage.setItem("ie_user", JSON.stringify(data.user));
      toast.success("Bienvenido");
      nav("/admin");
    } catch (err) {
      toast.error(
        formatApiErrorDetail(err.response?.data?.detail) || "Error de acceso"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-[#fafafa] px-6"
    >
      <div className="w-full max-w-md bg-white border border-black/8 p-8 md:p-10">
        <div className="flex items-center gap-2 mb-7">
          <span className="dot-red" />
          <span className="font-display font-bold tracking-tight text-sm">
            INSTITUTO <span className="text-[#c40000]">EUROPA</span>
          </span>
        </div>

        <h1 className="font-display font-semibold tracking-tighter text-3xl md:text-4xl text-[#0a0a0a]">
          Panel Admin
        </h1>
        <p className="mt-2 text-sm text-[#525252]">
          Acceso restringido al equipo de Instituto Europa.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div className="relative">
            <Mail
              size={16}
              strokeWidth={1.5}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500"
            />
            <input
              data-testid="admin-email-input"
              className="ie-input"
              style={{ paddingLeft: '2.5rem' }}
              type="email"
              placeholder="Correo"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="relative">
            <Lock
              size={16}
              strokeWidth={1.5}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500"
            />
            <input
              data-testid="admin-password-input"
              className="ie-input"
              style={{ paddingLeft: '2.5rem' }}
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center disabled:opacity-60"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>

        <a
          href="/"
          data-testid="admin-back-home"
          className="mt-8 block text-center text-xs uppercase tracking-[0.18em] text-[#525252] hover:text-[#0a0a0a]"
        >
          ← Volver al sitio
        </a>
      </div>
    </div>
  );
}
